import { Button } from "../Button/Button";
import { InputText } from "../InputText/InputText";
import React, { useEffect, useState } from "react";
import "./LoginPage.css";
import { Messages } from "./Messages";
import { Enter } from "../Utils/Keys";
import aderantTheme from "../Theme/AderantTheme";
/**
 * Component displaying a Login Dialog.
 */
export function Login(props) {
    const { appName, styles, onSignIn, errorMessage } = props;
    const loginContainerName = appName + " Login";
    const loginContainerId = props.id ?? loginContainerName.replaceAll(" ", "-");
    const [loginId, setLoginId] = useState(props.loginHint ?? "");
    const [isContinueButtonDisabled, setIsContinueButtonDisabled] = useState(loginId.length === 0);
    const loginTitle = Messages.LOGIN_TITLE.getMessage();
    const loginInstructions = Messages.LOGIN_INSTRUCTIONS.getMessage([appName]);
    const loginPrompt = props.loginPrompt ?? Messages.LOGIN_PROMPT.getMessage();
    const loginButtonText = Messages.LOGIN_BUTTON.getMessage();
    useEffect(() => {
        setIsContinueButtonDisabled(loginId.length === 0);
    }, [loginId]);
    const handleContinue = () => {
        if (loginId && onSignIn) {
            onSignIn(loginId);
        }
    };
    const handleKeyDown = (event) => {
        if (loginId && event.key === Enter.key) {
            handleContinue();
        }
    };
    const handleLoginIdChange = (event, value) => {
        setLoginId(value ?? "");
    };
    const defaultStyles = {
        loginContainer: {},
        loginHeader: {},
        loginTitle: {},
        loginInstructions: {},
        loginBody: {},
        loginId: {},
        continueButton: {}
    };
    if (errorMessage) {
        defaultStyles.loginId = { borderColor: aderantTheme.palette.error.main };
    }
    const combinedStyles = styles ? { ...defaultStyles, ...styles } : defaultStyles;
    const getErrorDisplay = (errorMessage) => {
        if (errorMessage) {
            return (React.createElement("div", { style: { color: aderantTheme.palette.error.main } },
                React.createElement("i", { "aria-label": "Login Error" }, errorMessage)));
        }
        else {
            return React.createElement("div", null);
        }
    };
    return (React.createElement("div", { id: loginContainerId, "aria-label": loginContainerName, className: "aderant-login", style: combinedStyles.loginContainer },
        React.createElement("div", { className: "aderant-login-header", style: combinedStyles.loginHeader },
            React.createElement("h1", { style: combinedStyles.loginTitle }, loginTitle),
            React.createElement("p", { style: combinedStyles.loginInstructions }, loginInstructions)),
        React.createElement("form", { className: "aderant-login-body", style: combinedStyles.loginBody },
            React.createElement(InputText, { id: "login-id", "aria-label": "Email Address", placeholder: loginPrompt, autofocus: true, autoComplete: "on", ariaAutoComplete: undefined, value: loginId, onChange: handleLoginIdChange, onKeyDown: handleKeyDown, style: combinedStyles.loginId }),
            getErrorDisplay(props.errorMessage),
            React.createElement(Button, { id: "continue-button", disabled: isContinueButtonDisabled, variant: "contained", size: "medium", rounded: true, onClick: handleContinue, style: combinedStyles.continueButton, text: loginButtonText, className: "continue-button" }))));
}
